let modules = {};

// 查找所有module
const files = require.context('.', true, /\.js$/);
files.keys().forEach((key) => {
  if (key === './index.js') return;
  Object.assign(modules, files(key).default)
});
export const PORTAL_TRACKER_KEY_MAP = {
  ...modules
}
